import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TerminalDataModel } from '@nutricontrol/app360-shared';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IrrigationCostsTableComponent } from './irrigation-costs-table/irrigation-costs-table.component';
import { FertilizationCostsTableComponent } from './fertilization-costs-table/fertilization-costs-table.component';
import { WaterSourcesTableComponent } from './water-sources-table/water-sources-table.component';
import { TranslationsLibService } from '@nutricontrol/app360-shared';
import { TerminalCurrencyDataModel } from '../reports.model';

@Component({
  selector: 'app-reports-configuration',
  templateUrl: './reports-configuration.component.html',
  styleUrls: ['./reports-configuration.component.scss'],
})
export class ReportsConfigurationComponent implements OnInit {
  @Input() terminals: TerminalDataModel[];
  configurationForm: FormGroup;
  terminal: TerminalDataModel;
  terminalCurrency?: TerminalCurrencyDataModel;

  @ViewChild('irrigationCostsTable')
  irrigationCostsTable: IrrigationCostsTableComponent;
  @ViewChild('fertilizationCostsTable')
  fertilizationCostsTable: FertilizationCostsTableComponent;
  @ViewChild('waterSourcesTable') waterSourcesTable: WaterSourcesTableComponent;

  constructor(
    public translationLib: TranslationsLibService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.configurationForm = this.fb.group({
      configuration: ['irrigationCosts'],
      terminal: [null],
    });
  }

  onTerminalSelected(terminal: TerminalDataModel) {
    this.terminal = terminal;
    setTimeout(() => {
      this.reloadTables();
    });
  }

  onTerminalCurrency(terminalCurrency?: TerminalCurrencyDataModel) {
    this.terminalCurrency = terminalCurrency;
    setTimeout(() => {
      this.reloadTables();
    });
  }

  onConfigurationTypeChanged() {
    setTimeout(() => {
      this.reloadTables();
    });
  }

  reloadTables() {
    if (
      this.configurationForm.get('configuration').value === 'irrigationCosts' &&
      this.irrigationCostsTable
    ) {
      this.irrigationCostsTable.loadIrrigationCosts();
    } else if (
      this.configurationForm.get('configuration').value ===
        'fertilizationCosts' &&
      this.fertilizationCostsTable
    ) {
      this.fertilizationCostsTable.loadFertilizationCosts();
    } else if (
      this.configurationForm.get('configuration').value === 'waterSources' &&
      this.waterSourcesTable
    ) {
      this.waterSourcesTable.loadWaterSources();
    }
  }
}
